import React, { useState, useEffect } from 'react'
import { Row, Col } from 'rsuite'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import { useCookies } from 'react-cookie'

import { startLoading, doneLoading } from '../../utils/loading'
import { getDashboardSchemaPage, getTermsURL } from '../../redux/actions/dashboard'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import WaitingForReview from '../../widgets/waitingReview/WaitingForReview'

import FindBudgetYear from '../../widgets/findBudgetYear/FindBudgetYear'
import ProjectStatusPending from '../../widgets/projectStatus/ProjectStatusPending'
import ProjectStatusInProgress from '../../widgets/projectStatus/ProjectStatusInProgress'
import SearchSubProject from './SearchSubProject'
import Notification from './Notification'
import ApproveWithdrawReviewDashboard from './ApproveWithdrawReviewDashboard'
import ApproveWithdrawReviewProjectDashboard from './ApproveWithdrawReviewProjectDashboard'

// widget
import Profile from '../../widgets/dashboard/Profile'
import ProjectCost from '../../widgets/dashboard/ProjectCost'
import ProposalProjectList from '../../widgets/projectList/ProposalProjectList'
import OngoingProjectList from '../../widgets/projectList/OngoingProjectList'
import AllProject from '../../widgets/dashboard/AllProject'
import WaitScrutinize from '../../widgets/dashboard/WaitScrutinize'
import WaitScreeningInitial from '../../widgets/dashboard/WaitScreeningInitial'
import WaitScreening from '../../widgets/dashboard/WaitScreening'
import WaitScreeningDepartment6 from '../../widgets/dashboard/WaitScreeningDepartment6'
import ContractStatusWait from '../../widgets/dashboard/ContractStatusWait'
import WaitForReviewer from '../../widgets/dashboard/WaitForReviewer'
import ExpertWaitScrutinizeApproval from '../../widgets/dashboard/ExpertWaitScrutinizeApproval'
import ApprovalBudget from '../../widgets/dashboard/ApprovalBudget'
import ProjectDashboard2 from '../../widgets/dashboard/ProjectDashboard2'
// import CookieWidget from '../../widgets/cookie/CookieWidget'
import { isEmpty } from 'lodash'
import MultiApproveReviewerGroup from '../../widgets/dataTable/MultiApproveReviewerGroup'
import WaitScrutinizeDep6 from '../../widgets/dashboard/WaitScrutinizeDep6'
import WaitContractCenterReview from '../../widgets/dashboard/WaitContractCenterReview'
import UpDownStreamWidget from '../../widgets/dashboard/UpDownStreamWidget'
import UserDashboardWidget from '../../widgets/dashboard/UserDashboardWidget'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import ContractChange from '../../widgets/dashboard/ContractChange'
import UpDownStreamContractWidget from '../../widgets/dashboard/UpDownStreamContractWidget'
import WaitReviewToClose from '../../widgets/dashboard/WaitReviewToClose'

export default function Dashboard() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  // const [cookies, setCookie] = useCookies(['accept_cookie'])
  // const [isShowCookie, setIsShowCookie] = useState(true)

  // const userType = location.search.substring(1)
  //let id = location.search.substring(1)
  // let id = sessionStorage.getItem('param')?.substring(1)

  useEffect(() => {
    // const acceptCookie = sessionStorage.getItem('accept-cookie')
    handelGetSchemaDashboard()
    // setIsShowCookie(isEmpty(acceptCookie) || acceptCookie == 'false')

    // 1 Jul
    console.log('Remove item in local storage')
    localStorage.removeItem('location')
    localStorage.removeItem('location_expires')
    localStorage.removeItem('location-zipcode')
    localStorage.removeItem('location-zipcode_expires')
    localStorage.removeItem('location_haveall')
    localStorage.removeItem('location_haveall_expires')
    localStorage.removeItem('userOpenMenu')

    sessionStorage.clear()
  }, [])

  // const onSubmitCookie = (value) => {
  //   // console.log('val ', value)
  //   // setIsShowCookie(value == false)
  //   let date = new Date()
  //   date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
  //   setCookie('accept_cookie', value, { path: '/', expires: date })
  //   // sessionStorage.setItem('accept-cookie', value)
  // }

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()

    const termsUrl = localStorage.getItem('termsUrl')
    if (isEmpty(termsUrl)) {
      await handelTermsURL()
    }

    try {
      const response = await getDashboardSchemaPage()

      if (response?.forms) {
        setSchema(response?.forms)
      } else {
        doneLoading()
        window.location.href = '/'
      }
    } catch (e) {
      console.log(e)

      setError({
        statusCode: e?.response?.status || 500,
        errorMessage: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handelTermsURL = async () => {
    const uid = localStorage.getItem('thp_user_uid')
    try {
      const response = await getTermsURL(uid)
      if (response?.termsUrl) {
        localStorage.setItem('termsUrl', response?.termsUrl)
      }
    } catch (e) {}
  }

  const renderRows = (rows, index, size, rsize) => {
    const MD_LG = size ? rsize : 24
    let form

    if (rows.subForms?.length > 0) {
      form = subForms(rows.subForms)
    } else {
      switch (rows.name) {
        case 'profile':
          form = (
            <>
              <Profile />
            </>
          )

          break
        case 'projectCost':
          form = (
            <>
              <ProjectCost />
            </>
          )

          break
        case 'contractStatusReport':
          form = <UpDownStreamContractWidget />
          break
        case 'coodinatorSummary':
          form = (
            <>
              <UpDownStreamWidget dashBoardName={'coodinatorSummary'} />
            </>
          )

          break
        case 'coodinatorSummary2':
          form = (
            <>
              <UpDownStreamWidget dashBoardName={'coodinatorSummary2'} />
            </>
          )

          break
        case 'userSummary':
          form = (
            <>
              <UserDashboardWidget />
            </>
          )
          break

        case 'statusProposalProject':
          form = <ProposalProjectList /> //ไม่ใช่ตาราง
          break
        case 'statusOngoingProject':
          form = <OngoingProjectList /> //ไม่ใช่ตาราง
          break
        case 'allProject':
          form = <AllProject />
          break
        case 'waitingForReview':
          form = <WaitingForReview />
          break
        case 'waitScrutinize':
          form = <WaitScrutinize />
          break
        case 'waitScrutinizeDep6':
          form = <WaitScrutinizeDep6 />
          break
        // case 'waitScrutinizeMulti':
        //   form = <MultiReviewGroup isNoSidebar />
        //   break
        case 'multiApproveReviewer':
          form = <MultiApproveReviewerGroup />
          break

        case 'findBudgetYear':
          form = <FindBudgetYear /> //ไม่ใช่ตาราง
          break
        case 'waitForReviewer':
          form = <WaitForReviewer />
          break
        case 'projectStatusPending':
          form = <ProjectStatusPending />
          break

        case 'projectStatusInProgress':
          form = <ProjectStatusInProgress />
          break
        case 'searchSubProject':
          form = <SearchSubProject />
          break
        case 'notification':
          form = <Notification height={rows.height} /> //ไม่ใช่ตาราง
          break
        case 'contractStatusWait':
          form = <ContractStatusWait />
          break
        case 'contractChange':
          form = <ContractChange />
          break
        case 'waitScreeningInitial':
          form = <WaitScreeningInitial />
          break
        case 'waitScreening':
          form = <WaitScreening />
          break
        case 'waitScreeningDepartment6':
          form = <WaitScreeningDepartment6 />
          break
        case 'expertWaitScrutinizeApproval':
          form = <ExpertWaitScrutinizeApproval />
          break
        // case 'subProject':
        //   form = <SubProject />
        //   break
        case 'projectDashboard2':
          form = <ProjectDashboard2 /> //ไม่ใช่ตาราง
          break
        case 'approveProject': //รายการที่รออนุมัติ
          form = <ApprovalBudget enableMulti={rows.isEnableMulti} />
          break
        // case 'approvalBudget':
        //   form = <ApprovalBudget enableMulti={true} />
        //   break
        case 'approveWithdrawReviewDashboard':
          form = <ApproveWithdrawReviewDashboard />
          break
        case 'approveWithdrawReviewProjectDashboard':
          form = <ApproveWithdrawReviewProjectDashboard />
          break
        case 'waitContractCenterReview':
          form = <WaitContractCenterReview />
          break
        case 'waitReviewToClose':
          form = <WaitReviewToClose />
          break
        default:
          break
      }
    }

    return (
      <Col xs={24} sm={24} md={MD_LG} lg={MD_LG} key={index}>
        {form}
      </Col>
    )
  }

  const subForms = (forms) => {
    return forms?.map((item, index) => {
      return renderRows(item, index, forms.length, item.col)
    })
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <div style={{ marginBottom: 30 }}>
        <>
          {/* {!cookies.accept_cookie && <CookieWidget onSubmit={onSubmitCookie} />} */}

          {schema?.dashBoardList &&
            schema.dashBoardList?.map((rows, index) => {
              return (
                <Row key={index}>
                  <>{renderRows(rows, index)}</>
                </Row>
              )
            })}
        </>
      </div>
    </div>
  )
}
